import { DriverDto, RecordOriginCode, RecordStatus, VehicleDto } from '@fleet-beat/api';
import {
  BaseEntityDto,
  CertificationEventCode,
  CombinedMalfunctionCode,
  DataDiagnosticCode,
  DutyEventCode,
  EngineEventCode,
  IntermediateEventCode,
  LogEventType,
  LogRecordStatus,
  LoginEventCode,
  MalfunctionDiagnosticCode,
  MalfunctionEventCode,
  PersonalUseEventCode,
  UserRole,
  ViolationTypeEnum,
  WarningType,
} from '@fleet-beat/core';

export interface DriverLogbookRecord {
  date?: string;
  isDst?: boolean;
  logs?: LogRecord[];
  shifts?: string[];
  cycles?: string[];
  coDriver?: {
    logs?: LogRecord[];
  };
  timers?: LogTimers;
  ssbTimers?: SSBSTimers;
  ssbs?: string[];
  maxTimers?: LogTimers;
  spent?: LogTimeSpent;
  certificationLog?: CertificationLog;
  violations?: LogbookRecordViolation[];
  warnings?: LogbookRecordWarning[];
  malfunctions?: LogbookRecordMalfunction[];
}

export interface DriverWeightStationLogs {
  date: string;
  logs: LogRecord[];
}

export interface LogbookRecordMalfunction extends BaseEntityDto {
  id: string;
  driverId: string;
  truckId: string;
  firstLogId: string;
  lastLogId: string;
  startedAt: string;
  endedAt: string;
  code: CombinedMalfunctionCode;
  metaData: {
    logs: {
      odometer: number;
      sequenceId: number;
      engineHours: number;
    }[];
  };
}

export interface LogbookRecordViolation {
  startedAt: string;
  endedAt: string;
  type: `${ViolationTypeEnum}`;
  id?: string;
}

export interface LogbookRecordWarning {
  id: string;
  type: WarningType;
}

export interface LogTimers {
  break: number;
  driving: number;
  shift: number;
  cycle: number;
  recap: number;
}

export interface SSBSTimers {
  date: number;
  driving: number;
  shift: number;
}

export interface LogTimeSpent {
  worked: number;
  driving: number;
  onDuty: number;
  offDuty: number;
  sleeperBerth: number;
  total?: number;
}

export interface CertificationLog {
  truckId: string;
  notes: string;
  startedAt: string;
  endedAt: string;
  certifyDate: string;
  driverSignatureUrl: string;
  isLocked: boolean;
}

export interface LogRecordAdditional {
  id?: string;
  startedAt?: string;
  status?: `${LogRecordStatus}`;
  endTime?: string;
  startTime?: string;
  duration?: string;
  endedAt?: string | null;
  dutyFirst?: boolean;
  truckId?: string;
  vehicleId?: string;
  relatedLogId?: string;
  dutyLast?: boolean;
  isShift?: boolean;
  isCycle?: boolean;
  markerDirection?: 'left' | 'right';
  isLocked?: boolean;
  isCoDriverLog?: boolean;
  isCycleLimitWarning?: boolean;
  isShiftLimitWarning?: boolean;
  isDrivingLimitWarning?: boolean;
  isSSB?: boolean;
}

export interface LogRecord extends BaseEntityDto, LogRecordAdditional {
  [key: string]: string | boolean | number | VehicleDto | DriverDto;
  id: string;
  driverId: string;
  coDriverId: string | null;
  truckId: string;
  truck?: VehicleDto;
  trailerNumber: string | null;
  vehicleId: string | null;
  eventType: LogEventType;
  eventCode:
    | PersonalUseEventCode
    | DutyEventCode
    | CertificationEventCode
    | LoginEventCode
    | EngineEventCode
    | IntermediateEventCode
    | MalfunctionEventCode;
  originCode: RecordOriginCode;
  recordStatus: RecordStatus;
  status: `${LogRecordStatus}`;
  creator: `${UserRole}`;
  startedAt: string;
  originalStartedAt: string;
  endedAt: string | null;
  originalEndedAt: string | null;
  notes: string | null;
  odometer: number;
  pairedDate?: string | null;
  pairedId?: string | null;
  distance?: number;
  originalOdometer: number;
  engineHours: number;
  lat: number | null;
  lon: number | null;
  address: string | null;
  shippingDocument: string | null;
  malfunctionDiagnostic: MalfunctionDiagnosticCode | DataDiagnosticCode | null;
  malfunction: boolean;
  diagnostic: boolean;
  sequenceId: string | null;
  certifyDate: string | null;
  driverSignatureUrl: string | null;
  isLocked: boolean;
  driver?: DriverDto;
  speed?: number;

  warning?: LogbookRecordWarning[];
  intermediateOutOfDriving: boolean;
  hover?: boolean;
  disabled?: boolean;
  different?: boolean;

  // NOTE mobile realated
  checked?: boolean;
  checkingDisabled?: boolean;
}
